import React from 'react';
import { CHART_CONFIGS } from '../utils';

type MetricSelectorProps = {
  selectedMetrics: Set<string>;
  onMetricToggle: (dataKey: string) => void;
};

export const MetricSelector: React.FC<MetricSelectorProps> = ({ selectedMetrics, onMetricToggle }) => {
  return (
    <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 mb-6">
      <h3 className="text-lg font-semibold text-gray-800 mb-3">重ね合わせ表示する指標を選択</h3>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3">
        {CHART_CONFIGS.map((config) => (
          <label key={config.dataKey} className="flex items-center space-x-2 cursor-pointer">
            <input
              type="checkbox"
              checked={selectedMetrics.has(config.dataKey)}
              onChange={() => onMetricToggle(config.dataKey)}
              className="w-4 h-4 rounded focus:ring-2"
              style={{ accentColor: config.color }}
            />
            <span className="text-sm text-gray-700">{config.title}</span>
          </label>
        ))}
      </div>
    </div>
  );
};
